import React from 'react'
import NumberFormat from 'react-number-format'
import TextField, { TextFieldProps } from '@mui/material/TextField'

interface NumberFormatCustomProps {
  ref: (instance: NumberFormat<any> | null) => void
  onChange: (event: { target: { name: string; value: string } }) => void
  name: string
}

const NumberFormatCustom = React.forwardRef(function NumberFormatCustom(props: NumberFormatCustomProps, ref) {
  return (
    <NumberFormat
      {...props}
      onChange={() => {}}
      onValueChange={values => {
        props.onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        })
      }}
      onPaste={(e: React.ClipboardEvent<HTMLInputElement>) => {
        const pasted = e.clipboardData.getData('text')
        if (/[,]/.test(pasted) || /[a-zA-ZčřžšťďňůúýáíéěóKkČč]+/.test(pasted)) {
          e.preventDefault()
          const cleaned = pasted
            .replace(/[^0-9,.\-]/g, '')
            .replace(',', '.')
          document.execCommand('insertText', false, cleaned)
        }
      }}
      getInputRef={ref}
      thousandSeparator=" "
    />
  )
})

export const NumericInput: React.FC<TextFieldProps> = props => {
  return (
    <TextField
      variant="standard"
      {...props}
      InputProps={{
        inputComponent: NumberFormatCustom as any,
      }}
    />
  )
}
